import React, { Component } from 'react';

import hexRgb from 'hex-rgb';
import { connect } from 'react-redux';

import { ICustomizationAnswer } from '../../../store/slices/customization/customization';

interface Props {
  foregroundColor: string;
  backgroundColor: string;
  answer: ICustomizationAnswer;
}

class KeyDriverStyle extends Component<Props> {
  render() {
    const { foregroundColor, backgroundColor, answer } = this.props;
    const answerFont = answer && answer.font ? `font-family: ${answer.font}; color: ${answer.color} !important;` : '';
    const selectedAnswerFont = answer && answer.font ? `font-family: ${answer.font}; color: white !important;` : '';
    const [fgRed, fgGreen, fbBlue] = hexRgb(foregroundColor, { format: 'array' });
    return (
      <style type="text/css" scoped>
        {`
        /* scale */
          .key-driver .driver-name {
            ${answerFont} 
          }
          .ui.card .content .scale.rating .rating-icon,
          .ui.card .content .scale.rating .rating-icon:hover {
            color: ${foregroundColor};
            opacity: 1;
          }
          .scale-label * {
            color: ${answer.color};
            font-family: ${answer.font};
          }
          .rc-slider-track {
            background-color: ${foregroundColor};
          }
          .rc-slider-handle:hover,
          .rc-slider-handle:focus {
            border-color: ${foregroundColor} !important;
            box-shadow: 0 0 1px 6px ${foregroundColor}25 !important;
          }
          .sx-rating-icons,
          .delete-scale-label {
            color: ${foregroundColor} !important;
          }

        /* grid */
          .grid .bar, .grid th, .max-diff .max-diff-header, .max-diff .max-diff-header th {
            ${answerFont}
            background-color: ${backgroundColor};
          }
          .grid .grid-columns, .grid .grid-rows-header,
          .nps .npsLabel,
          .nps .npsCell {
            ${answerFont}
          }
          .nps .npsCell.selected {
            ${selectedAnswerFont}
          }
          .max-diff tbody tr td, .max-diff tbody tr .sub-row td {
            ${answerFont}
          }
          .max-diff {
            justify-content: center;
          }
          .grid .cell, .max-diff .cell {
            border-color: ${foregroundColor};
          }
          .grid .cell:hover, .max-diff .cell:hover,
          .grid .cell:focus, .max-diff .cell:focus,
          .grid .grid-cell:hover .cell,
          .grid .grid-cell:focus .cell {
            box-shadow: 0 0 0 8px rgba(${fgRed}, ${fgGreen}, ${fbBlue}, 0.1);
          }
          .mobile .grid .cell:hover, .mobile .max-diff .cell:hover {
            box-shadow: none;
          }
          .grid .cell.checkbox.selected, .grid .cell.selected, .max-diff .cell.checkbox.selected {
            background-color: ${foregroundColor};
          }
          .nps .npsCell.selected,
          .nps .npsCell.selected:hover,
          .nps .npsCell.selected:focus {
            background-color: ${foregroundColor};
            border-color: ${foregroundColor};
          }
          .nps .npsCell:hover,
          .nps .npsCell:focus {
            background-color: ${foregroundColor}40;
          }
          .nps textarea, .nps textarea:hover {
            border-color: ${foregroundColor};
          }
          .nps .cellsContainer {
            outline-color: ${foregroundColor};
          }
      
        
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    foregroundColor: customization.foregroundColor,
    backgroundColor: customization.backgroundColor,
    answer: customization.answer,
  };
};

export default connect(mapStateToProps)(KeyDriverStyle);
